import initDOMHelper from './domHelper'
import handlersStack from './HandlersStack'
import {EVENTS} from './constants'

initDOMHelper()

export const KEY_HANDLERS = {
    onKeyDown: (handler) => handlersStack.addHandler(EVENTS.KEY_DOWN, handler),
    onKeyUp: (handler) => handlersStack.addHandler(EVENTS.KEY_UP, handler),
    onKeyPress: (handler) => handlersStack.addHandler(EVENTS.KEY_PRESS, handler)
}

export const onKeyDown = KEY_HANDLERS.onKeyDown
export const onKeyUp = KEY_HANDLERS.onKeyUp
export const onKeyPress = KEY_HANDLERS.onKeyPress

export * from './keyHelpers'
export * from './keyModifiersHelper'
export default KEY_HANDLERS
window.KEY_HANDLERS = KEY_HANDLERS



// WEBPACK FOOTER //
// ./web/js/keyHandlers/index.js